import React from 'react';
import './Layout.scss';
import SideBar from '../SideBar/SideBar';
import useModals from '@/shared/hooks/useModal';
import MenuNav from '@/shared/ui/Navs/MenuNavs';
import { useNavigate } from 'react-router-dom';

export function BaseLayout({ children }: { children: any }) {
    return (
        <div className="PageLayout">
            {children}
        </div>
    )
}

const headerPaths = [
    {
        path: "/projects",
        element: ({ onClick, active }: any) => <MenuNav onClick={onClick} active={active} style={{color: active ? "black": "white"}}>Проекты</MenuNav>
    },
    {
        path: "/employees",
        element: ({ onClick, active }: any) => <MenuNav onClick={onClick} active={active} style={{color: active ? "black": "white"}}>Сотрудники</MenuNav>
    },
]

export function AdminLayout({ title, children, sidebarSlot=<SideBar/> }: any) {
    const {modal} = useModals();
    const navigate = useNavigate();
    const currentPath = window.location.pathname
    return (
        <div className='PageLayout' style={{ backgroundColor: '#FAFAFA' }}>
            <div className='PageLayoutHeader'>
                <a href="/">
                    <h1 className='text-24'>ProgaTMS</h1>
                </a>
                <nav className='HeaderNav'>
                    {headerPaths.map(el => (
                        el.element({ onClick: () => navigate(el.path), active: currentPath === el.path || currentPath === el.path + "/" })
                    ))}
                </nav>
            </div>
            <div className='PageLayoutAdmin'>
                {sidebarSlot}
                <div className='PageLayoutAdminContent' style={{ width: "100%", maxHeight: "calc(100svh - 97px)" }}>
                    {children}
                </div>
            </div>
            {modal}
        </div>
    )
}

export function MobileLayout({title, children}: any) {
    return (
        <div className='PageLayoutMobile'>
            {children}
        </div>
    )
}